import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
setupInterceptorsTo(axios);

export type EmbedContent =
{
    embedToken: string;
    embedUrl: string;
    reportId: string;
};

class PowerBiService
{
    public getReportTokens = async (reportId: string): Promise<EmbedContent> =>
    {
        let url: string = `${proxyUrl}/powerBIToken/${encodeURIComponent(reportId)}`;
        const req = await axios.get(url);
        return req.data;
    }
}

const powerBiServices = new PowerBiService();
export default powerBiServices;